import _toConsumableArray from "E:/work/\u521B\u5947/\u95EE\u5377/answer-h5-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/explanation.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8e9cffda"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "ques-text"
};
var _hoisted_3 = ["disabled", "id", "onUpdate:modelValue"];
var _hoisted_4 = {
  key: 1,
  class: "title-tip"
};
var _hoisted_5 = {
  key: 0
};
var _hoisted_6 = {
  class: "feedback animate__animated animate__fadeInDown"
};
var _hoisted_7 = {
  key: 0,
  class: "left red"
};
var _hoisted_8 = {
  key: 1,
  class: "left green"
};
var _hoisted_9 = {
  key: 2,
  class: "left green"
};
var _hoisted_10 = {
  class: "right"
};
var _hoisted_11 = {
  key: 0,
  class: "explanation"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
import '../choice/css/choice.scss';
import { ref, onMounted, computed } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';
export default {
  __name: 'MulBlankInput',
  props: {
    data: {
      type: Object,
      default: null
    },
    quesIndex: {
      type: Number,
      default: 0
    },
    isReview: {
      type: Boolean,
      default: false
    }
  },
  emits: ['inputChange', 'changeVerify'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var value = ref('');
    var rightType = ref(0);
    var rightAnswerList = props.data.optionVoList.map(function (item) {
      return item.answer;
    });

    // 回顾设置对错
    if (props.data.value) {
      var valueList = Array.from(new Set(JSON.parse(props.data.value)));
      var res = valueList.filter(function (item) {
        return rightAnswerList.includes(item);
      });

      // 1 为全部命中答案正确
      if (res.length === rightAnswerList.length) {
        rightType.value = 1;
      }
      // 2 为部分正确
      if (res.length > 0 && res.length < rightAnswerList.length) {
        rightType.value = 2;
      }
    }
    var showList = computed(function () {
      var _props$data;
      return (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.title.trim().split(/__+/g);
    });
    var answerList = computed(function () {
      var _props$data2, _props$data3, _props$data4;
      var values = (_props$data2 = props.data) !== null && _props$data2 !== void 0 && _props$data2.value ? JSON.parse((_props$data3 = props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.value) : [];
      return (_props$data4 = props.data) === null || _props$data4 === void 0 || (_props$data4 = _props$data4.optionVoList) === null || _props$data4 === void 0 ? void 0 : _props$data4.map(function (item, index) {
        return {
          questionKey: item.questionKey,
          optionKey: item.optionKey,
          answerContent: values[index] || ''
        };
      });
    });
    var handleInputBlur = function handleInputBlur() {
      emits('inputChange', {
        questionKey: props.data.questionKey,
        questionType: props.data.questionType,
        answers: _toConsumableArray(answerList.value)
      });
    };
    onMounted(function () {
      if (props.data.value) {
        value.value = props.data.value;
      }
    });
    onBeforeRouteUpdate(function () {
      if (props.data.value) {
        value.value = props.data.value;
      }
    });
    return function (_ctx, _cache) {
      var _props$data5, _ctx$$store$getters, _ctx$$store$getters2, _props$data6, _ctx$$store$getters$g;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("h1", {
        class: _normalizeClass(["choice-title blank-wrap", {
          required: (_props$data5 = __props.data) === null || _props$data5 === void 0 ? void 0 : _props$data5.isRequired
        }])
      }, [(_ctx$$store$getters = _ctx.$store.getters) !== null && _ctx$$store$getters !== void 0 && (_ctx$$store$getters = _ctx$$store$getters.getQuesInfo) !== null && _ctx$$store$getters !== void 0 && _ctx$$store$getters.showIndex ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString("".concat(__props.quesIndex + 1, "\u3001")), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, function (item, index) {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: "".concat(index).concat(item)
        }, [_createElementVNode("span", _hoisted_2, _toDisplayString(item), 1), index !== showList.value.length - 1 ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 0,
          disabled: __props.isReview,
          class: "blank-input",
          id: "inputId".concat(index),
          onBlur: handleInputBlur,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return answerList.value[index].answerContent = $event;
          },
          type: "text"
        }, null, 40, _hoisted_3)), [[_vModelText, answerList.value[index].answerContent]]) : _createCommentVNode("", true)], 64);
      }), 128)), (_ctx$$store$getters2 = _ctx.$store.getters) !== null && _ctx$$store$getters2 !== void 0 && _ctx$$store$getters2.isShowType ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (完型填空) ")) : _createCommentVNode("", true)], 2), __props.data.questionType !== 11 && __props.data.questionType !== 16 && __props.data.questionType !== 25 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.isReview ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("template", _hoisted_6, [rightType.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 答案：错误 ")) : _createCommentVNode("", true), rightType.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, "答案：正确")) : _createCommentVNode("", true), rightType.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "答案：部分正确")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_10, " 正确答案：" + _toDisplayString(_unref(rightAnswerList) && _unref(rightAnswerList).join(',')), 1)]), (_props$data6 = __props.data) !== null && _props$data6 !== void 0 && _props$data6.explanation && ((_ctx$$store$getters$g = _ctx.$store.getters.getQuesSetting) === null || _ctx$$store$getters$g === void 0 ? void 0 : _ctx$$store$getters$g.isExplanation) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("p", null, "解析：" + _toDisplayString(__props.data.explanation), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
    };
  }
};